import Vue from "vue"
import Router from "vue-router"
import routes from './routes'
import { checkRegistrationProgress } from '@/views/ksH5RealName/server/ksH5RealName'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 如果是跳快手实名认证相关页面的，需要做一些登录拦截
  if (to.path.includes('/ksH5RealName')) {
    const isLoginPage = ['/ksH5RealName', '/ksH5RealName/index'].includes(to.path);
    const hasToken = localStorage.getItem('ksH5token');

    // 未登录状态
    if (!hasToken) {
      // 如果是登录页且来源也是登录页，阻止重复跳转
      if (isLoginPage && ['/ksH5RealName', '/ksH5RealName/index'].includes(from.path)) {
        next(false);
        return;
      }
      // 非登录页跳转到登录页，登录页直接通过
      next(isLoginPage ? undefined : '/ksH5RealName');
      return;
    }
    checkRegistrationProgress();
  }
  next()
});

export default router



